import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { Mail, Phone } from "react-feather"
import { Logo } from "./utils"
import Navlinks from "./navigation-list"
import SocialLinks from "../utils/sociallinks"
import { FooterLinksQuery } from "./__generated__/FooterLinksQuery"

export default function() {
    const query = useStaticQuery<FooterLinksQuery>(graphql`
        query FooterLinksQuery {
            site {
                siteMetadata {
                    title
                    introTag
                    contact {
                        mail
                        phone
                    }
                }
            }
        }
    `)

    const meta = query.site.siteMetadata
    const contact = meta.contact

    return (
        <footer className="footer">
            <div className="large-container pt-20 pb-10 lg:pt-28">
                <div className="flex flex-wrap items-start justify-between">
                    <div className="w-full lg:w-1/3 mb-12 lg:mb-0">
                        <Link to="/" title={meta.title} className="inline-block">
                            <Logo className="brand-mark w-20" />
                        </Link>
                        <p
                            className="mt-6 font-display text-2xl leading-snug"
                            style={{ color: "rgba(251,249,245,0.92)" }}
                        >
                            {meta.introTag}
                        </p>
                    </div>

                    <div className="w-full sm:w-1/2 lg:w-auto mb-12 lg:mb-0">
                        <p className="eyebrow mb-6">Nawigacja</p>
                        <Navlinks
                            className="footer-nav"
                            liClassName="block mb-3"
                            withThemeSwitch={false}
                        />
                    </div>

                    <div className="w-full sm:w-1/2 lg:w-auto">
                        <p className="eyebrow mb-6">Kontakt</p>
                        <ul>
                            {contact.mail && (
                                <li className="flex items-center mb-3">
                                    <Mail size={15} strokeWidth={1.4} />
                                    <a
                                        className="ml-3"
                                        href={"mailto:" + contact.mail}
                                    >
                                        {contact.mail}
                                    </a>
                                </li>
                            )}
                            {contact.phone && (
                                <li className="flex items-center">
                                    <Phone size={15} strokeWidth={1.4} />
                                    <a
                                        className="ml-3"
                                        href={"tel:" + contact.phone}
                                    >
                                        {contact.phone}
                                    </a>
                                </li>
                            )}
                        </ul>
                        <SocialLinks className="mt-8" />
                    </div>
                </div>

                <div className="rule mt-16 mb-8"></div>

                <div className="flex flex-wrap items-center justify-between">
                    <p className="meta" style={{ color: "rgba(251,249,245,.5)" }}>
                        &copy; {new Date().getFullYear()} {meta.title}
                    </p>
                    <p className="meta" style={{ color: "rgba(251,249,245,.5)" }}>
                        Województwo Mazowieckie
                    </p>
                </div>
            </div>
        </footer>
    )
}
